export const index = function (state) {
  if (state.index.data) {
    state.index.data.sort((a, b) => b.id - a.id);
  }
  return state.index;
};

export const orderday = (state) => state.orderday;
export const orders = (state) => state.orders;
